import { useMemo, useState, useEffect } from "react";
import { es } from "date-fns/locale";
import { Calendar } from "@/components/ui/calendar";
import { clDay, clHM } from "@/lib/chileTime";

const p2 = (n) => String(n).padStart(2, "0");
const toStr = (d) => `${d.getFullYear()}-${p2(d.getMonth() + 1)}-${p2(d.getDate())}`;
const toDate = (s) => { const [y, m, d] = s.split("-").map(Number); return new Date(y, m - 1, d); };


export function SessionsPreviewCalendar({ sessions, date, times = [], repeat, weeks, min, max, onPick }) {
  const active = useMemo(() => sessions.filter((s) => s.status !== "cancelled").map((s) => s.starts_at), [sessions]);
  const created = useMemo(() => new Set(active.map(clDay)), [active]);
  const slots = useMemo(() => new Set(active.map((d) => `${clDay(d)} ${clHM(d)}`)), [active]);
  const pending = useMemo(() => {
    if (!date) return [];
    const base = toDate(date);
    return Array.from({ length: repeat ? weeks : 1 }, (_, i) => toStr(new Date(base.getFullYear(), base.getMonth(), base.getDate() + i * 7)))
      .filter((s) => s <= max);
  }, [date, repeat, weeks, max]);
  const conflicts = pending.filter((s) => times.some((t) => slots.has(`${s} ${t}`)));
  const [month, setMonth] = useState(() => (date ? toDate(date) : toDate(min)));
  useEffect(() => { if (date) setMonth(toDate(date)); }, [date]);

  const modifiers = {
    created: [...created].filter((s) => !pending.includes(s) || !conflicts.includes(s)).map(toDate),
    pending: pending.filter((s) => !created.has(s)).map(toDate),
    conflict: conflicts.map(toDate),
    chosen: date ? [toDate(date)] : [],
  };
  return (
    <div className="rounded-xl border border-border p-2" data-testid="sessions-preview-calendar">
      <Calendar mode="single" locale={es} weekStartsOn={1} month={month} onMonthChange={setMonth}
        fromDate={toDate(min)} toDate={toDate(max)} disabled={[{ before: toDate(min) }, { after: toDate(max) }]}
        selected={undefined} onSelect={(d) => d && onPick(toStr(d))}
        className="p-1 mx-auto w-fit"
        modifiers={modifiers}
        modifiersClassNames={{
          created: "!bg-primary !text-primary-foreground font-semibold",
          pending: "!bg-primary/15 !text-primary border-2 border-dashed border-primary font-semibold",
          conflict: "!bg-amber-100 !text-amber-800 border-2 border-amber-400 font-semibold",
          chosen: "ring-2 ring-offset-2 ring-primary",
        }} />
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground px-1 pb-1" data-testid="sessions-preview-legend">
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-primary" />{created.size} creada{created.size === 1 ? "" : "s"}</span>
        <span className="flex items-center gap-1"><span className="w-3 h-3 rounded bg-primary/15 border border-dashed border-primary" />{pending.filter((s) => !conflicts.includes(s)).length} por agregar</span>
        {conflicts.length > 0 && <span className="flex items-center gap-1 text-amber-700" data-testid="sessions-preview-conflict"><span className="w-3 h-3 rounded bg-amber-100 border border-amber-400" />{conflicts.length} repetida{conflicts.length === 1 ? "" : "s"}</span>}
      </div>
      <p className="text-[11px] text-center text-muted-foreground pb-1">El día elegido se marca con un anillo. Ámbar = ya existe una sesión a esa hora.</p>
    </div>
  );
}
